import {
  Box,
  Container,
  Heading,
  HStack,
  Text,
  VStack,
  useColorModeValue,
} from "@chakra-ui/react";
import { ExperienceGrid } from "../components/experience/ExperienceGrid";
import { AboutMe } from "../components/aboutme/AboutMe";
import GitHubIcon from "../shared/GitHubIcon";
import LinkedInIcon from "../shared/LinkedInIcon";
import LeetCodeIcon from "../shared/LeetCode";
import EmailIcon from "../shared/EmailIcon";
import { ProjectGridSingle } from "../components/project/ProjectGrid";

export const Homepage = () => {
  const textColor = useColorModeValue("gray.800", "gray.100");
  const accentColor = "accent.400";
  const iconColor = useColorModeValue("gray.600", "white");
  const sectionHeadingColor = useColorModeValue("gray.800", "white");
  const sectionBorderColor = useColorModeValue("gray.200", "whiteAlpha.100");

  return (
    <Box as="main" pb={20}>
      {/* Hero */}
      <Box
        pt={{ base: 12, md: 20 }}
        pb={{ base: 16, md: 24 }}
        px={{ base: 4, md: 0 }}
      >
        <Container maxW="3xl">
          <VStack align="start" spacing={6} textAlign="left">
            <Text
              fontSize="sm"
              fontWeight="600"
              textTransform="uppercase"
              letterSpacing="wider"
              color={accentColor}
            >
              Backend Developer
            </Text>
            <Heading
              as="h1"
              size="2xl"
              fontWeight="700"
              letterSpacing="-0.03em"
              lineHeight="1.15"
              color={textColor}
            >
              Leonel Gonçalves
            </Heading>
            <Box maxW="xl">
              <AboutMe />
            </Box>
            <HStack spacing={4} pt={2} alignItems="center">
              <GitHubIcon color={iconColor} />
              <LinkedInIcon color={iconColor} />
              <LeetCodeIcon color={iconColor} />
              <EmailIcon color={iconColor} />
            </HStack>
          </VStack>
        </Container>
      </Box>

      {/* Experience */}
      <Box py={{ base: 10, md: 14 }} borderTopWidth="1px" borderColor={sectionBorderColor}>
        <Container maxW="3xl">
          <VStack align="stretch" spacing={8}>
            <Heading
              as="h2"
              size="md"
              fontWeight="600"
              color={sectionHeadingColor}
              letterSpacing="-0.02em"
            >
              Experience
            </Heading>
            <ExperienceGrid />
          </VStack>
        </Container>
      </Box>

      {/* Projects */}
      <Box py={{ base: 10, md: 14 }} borderTopWidth="1px" borderColor={sectionBorderColor}>
        <Container maxW="3xl">
          <VStack align="stretch" spacing={8}>
            <Heading
              as="h2"
              size="md"
              fontWeight="600"
              color={sectionHeadingColor}
              letterSpacing="-0.02em"
            >
              Projects
            </Heading>
            <ProjectGridSingle />
          </VStack>
        </Container>
      </Box>
    </Box>
  );
}
